import { sortApiNamesByProductLevel } from 'pricing-pages-lib/utils/sortingUtils';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function isFeatureRecord(feature) {
  return typeof feature === 'object' && feature !== null && 'descriptions' in feature && 'displayName' in feature && 'freeUserAccessLevel' in feature && 'featureId' in feature && 'shortName' in feature && 'shouldUseDefaultLimits' in feature && 'shortLimits' in feature && 'longLimits' in feature && 'featureCategory' in feature && 'productApiNames' in feature;
}
function isGrowthFeature(feature) {
  return typeof feature === 'object' && feature !== null && 'defaultDescription' in feature && typeof feature.defaultDescription === 'string';
}
const removeBreaks = content => {
  const formattedSections = [];
  if (!content) {
    return formattedSections;
  }
  const sections = content.split(/<br\/>|<br \/>/);
  sections.forEach((section, index) => {
    formattedSections.push( /*#__PURE__*/_jsx(SanitizedText, {
      className: "m-all-0",
      body: section,
      formattingOptions: {
        isPlainText: false,
        shouldPreserveNewlines: true,
        shouldOpenLinksInNewTab: true
      }
    }, index));
  });
  return formattedSections;
};
const TranslatedFeature = ({
  feature,
  productLevel,
  attribute,
  useFeatureStore = true
}) => {
  if (useFeatureStore) {
    if (attribute === 'name') return /*#__PURE__*/_jsx(_Fragment, {
      children: feature.displayName
    });
    if (isGrowthFeature(feature) && attribute === 'description') {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: removeBreaks(feature.defaultDescription)
      });
    }
    if (isFeatureRecord(feature)) {
      const featureKey = attribute === 'description' ? 'descriptions' : attribute;
      const {
        [featureKey]: translations
      } = feature;
      if (!translations) {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }
      let apiName = CRM_SUITE_STARTER_BUNDLE;
      if (productLevel) {
        const productFromLevel = Object.keys(translations).find(key => key.includes(productLevel.toLocaleLowerCase()));
        if (productFromLevel) {
          apiName = productFromLevel;
        }
      }
      let translation = apiName && translations[apiName];
      if (translation) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: removeBreaks(translation)
        });
      }

      // fallback
      const highestTierProduct = sortApiNamesByProductLevel(feature.productApiNames).at(-1);
      translation = highestTierProduct && translations[highestTierProduct];
      if (translation) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: removeBreaks(translation)
        });
      }
    }
  }
  return null;
};
export default TranslatedFeature;